import { FormProvider, useForm } from "react-hook-form";
import axios from "axios";
import { useState } from "react";
import { message } from "antd"; // Ant Design message import kiya

import { QuotationFormStyle, StepsStyle } from "./QuotationForm.style";
import Step1 from "./Steps/Step1";
import { Button } from "../common";
import { ButtonType } from "../common/Button/Button";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import FinalStep from "./Steps/FinalStep";

const LAST_STEP = 3;

const items = [{ title: "" }, { title: "" }, { title: "" }];

const QuotationForm = () => {
  const [step, setStep] = useState(0);

  const methods = useForm({
    defaultValues: {
      from: "",
      to: "",
      date: "",
      transportType: "",
      make: "",
      model: "",
      year: "",
      name: "",
      email: "",
      phone: "",
      smsConsent: false,
      terms: false,
    },
  });

  const handleFormSubmit = async (values: any) => {
    if (step !== LAST_STEP - 1) {
      setStep(step + 1);
      return;
    }

    try {
      // ✅ FIX: Sending data as JSON object instead of URL parameters
      const quoteData = {
        subject: "Quote",
        formType: "quotation",
        from: values.from || "",
        to: values.to || "",
        date: values.date || "",
        transportType: values.transportType || "",
        make: values.make || "",
        model: values.model || "",
        year: values.year || "",
        name: values.name || "",
        email: values.email || "",
        phone: values.phone || "",
        smsConsent: values.smsConsent ? "Yes" : "No",
      };

      await axios.post("/php/mail.php", quoteData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      message.success("Quote request sent successfully!");
      setStep(step + 1);
    } catch (error) {
      console.error("Quote form submit error:", error);
      message.error("Failed to send quote. Please try again.");
    }
  };

  return (
    <FormProvider {...methods}>
      <QuotationFormStyle onSubmit={methods.handleSubmit(handleFormSubmit)}>
        <h2 className="form-heading">
          Get a Free
          <p>Instant Quote</p>
        </h2>

        <StepsStyle current={step} labelPlacement="vertical" items={items} />

        {step === 0 && <Step1 />}
        {step === 1 && <Step2 />}
        {step === 2 && <Step3 />}
        {step === 3 && <FinalStep />}

        {step !== LAST_STEP && (
          <Button
            label={step === LAST_STEP - 1 ? "Get a Quote" : "Next Step"}
            className="steps-button"
            type={ButtonType.filled}
          />
        )}
      </QuotationFormStyle>
    </FormProvider>
  );
};

export default QuotationForm;
